"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNextSlide = void 0;
var _constants = require("../constants");
const isNextSlide = ({
  currentSlide,
  maxVisibleItems = _constants.MAX_VISIBLE_PAGINATION_ITEMS,
  slidesCount,
  slideIndex
}) => slidesCount > maxVisibleItems && slideIndex === currentSlide + 2;
exports.isNextSlide = isNextSlide;
